import { isClient } from '@/lib/utils';

export const clearStorage = (): void => {
  if (isClient) {
    localStorage.clear();
  }
};

export const setItem = (key: string, value: string): void => {
  if (isClient) {
    localStorage.setItem(key, value);
  }
};

export const getItem = (key: string): string | null => {
  return isClient ? localStorage.getItem(key) : null;
};

export const removeItem = (key: string): void => {
  if (isClient) {
    localStorage.removeItem(key);
  }
};
